export const COACH_NAVIGATION = [
  {
    name: 'Dashboard',
    href: '/productivity-coaching',
    icon: 'dashboard',
    description: 'Performance Dashboard',
  },
  {
    name: 'Agents',
    href: '/agents',
    icon: 'agents',
    description: 'Agent roster',
  },
  {
    name: 'Accountability',
    href: '/accountability',
    icon: 'accountability',
    description: 'Daily accountability',
  },
  {
    name: 'Pipeline',
    href: '/pipeline',
    icon: 'pipeline',
    description: 'Deal pipeline',
  },
  {
    name: 'Training',
    href: '/classes',
    icon: 'training',
    description: 'Classes and calendar',
  },
  {
    name: 'Resources',
    href: '/resources',
    icon: 'resources',
    description: 'Agent Resources Library',
  },
  {
    name: 'Settings',
    href: '/settings',
    icon: 'settings',
    description: 'Account and organization settings',
  },
];
